package io.github.ele4326.emilyeby

import com.varabyte.kobweb.compose.css.ScrollBehavior
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.forms.ButtonStyle
import com.varabyte.kobweb.silk.components.forms.ButtonVars
import com.varabyte.kobweb.silk.components.layout.HorizontalDividerStyle
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.init.registerStyleBase
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.addVariantBase
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.theme.colors.palette.color
import com.varabyte.kobweb.silk.theme.colors.palette.toPalette
import com.varabyte.kobweb.silk.theme.modifyStyleBase
import org.jetbrains.compose.web.css.*

@InitSilk
fun initSiteStyles(ctx: InitSilkContext) {
    // This site does not need scrolling itself, but this is a good demonstration for how you might enable this in your
    // own site. Note that we only enable smooth scrolling unless the user has requested reduced motion, which is
    // considered a best practice.
    ctx.stylesheet.registerStyle("html") {
        cssRule(CSSMediaQuery.MediaFeature("prefers-reduced-motion", StylePropertyValue("no-preference"))) {
            Modifier.scrollBehavior(ScrollBehavior.Smooth)
        }
    }

    ctx.stylesheet.registerStyleBase("body") {
        Modifier
            .fontFamily("Poppins", "sans-serif")
            .fontSize(20.px)
            .lineHeight(1.5)
    }

    // Silk dividers only extend 90% by default; we want full width dividers in our site
    ctx.theme.modifyStyleBase(HorizontalDividerStyle) {
        Modifier.fillMaxWidth()
    }
}

val HeadlineTextStyle = CssStyle.base {
    Modifier
        .fontFamily("Zen Old Mincho")
        .fontSize(60.px)
        .textAlign(TextAlign.Start)
        .lineHeight(1.2) //1.5x doesn't look as good on very large text
}

val SubheadlineTextStyle = CssStyle.base {
    Modifier
        .fontFamily("Poppins", "sans-serif")
        .fontSize(32.px)
        .textAlign(TextAlign.Start)
}

val Header3SansSerifTextStyle = CssStyle.base {
    Modifier
        .fontFamily("Poppins", "sans-serif")
        .fontSize(32.px)
        .textAlign(TextAlign.Start)
        .fontWeight(600)
}
val Header4SansSerifTextStyle = CssStyle.base {
    Modifier
        .fontFamily("Poppins", "sans-serif")
        .fontSize(24.px)
        .textAlign(TextAlign.Start)
        .fontWeight(600)
}

val Body2SansSerifTextStyle = CssStyle.base {
    Modifier
        .fontFamily("Poppins", "sans-serif")
        .fontSize(18.px)
        .textAlign(TextAlign.Start)
}
val Body3SansSerifTextStyle = CssStyle.base {
    Modifier
        .fontFamily("Poppins", "sans-serif")
        .fontSize(16.px)
        .textAlign(TextAlign.Start)
}

val CircleButtonVariant = ButtonStyle.addVariantBase {
    Modifier.padding(0.px).borderRadius(50.percent)
}

val UncoloredButtonVariant = ButtonStyle.addVariantBase {
    Modifier.setVariable(ButtonVars.BackgroundDefaultColor, Colors.Transparent)
}
